import type { CSSProperties } from 'react'
import type { ToasterProps } from 'sonner'

import { Toaster as Sonner } from 'sonner'
import {
    CircleCheck,
    Info,
    LoaderCircle,
    OctagonX,
    TriangleAlert
} from 'lucide-react'

/** Toast notifications. Trigger them anywhere with `toast.success(...)` from 'sonner'. */
const Toaster = ({ ...props }: ToasterProps) => {
    return (
        <Sonner
            theme='light'
            className='toaster group'
            icons={{
                success: <CircleCheck className='size-5 text-sage-strong' />,
                info: <Info className='size-5 text-macro-fiber' />,
                warning: <TriangleAlert className='size-5 text-butter-ink' />,
                error: <OctagonX className='size-5 text-destructive' />,
                loading: <LoaderCircle className='size-5 animate-spin text-sage-strong' />
            }}
            style={
                {
                    '--normal-bg': 'var(--popover)',
                    '--normal-text': 'var(--popover-foreground)',
                    '--normal-border': 'var(--border)',
                    '--border-radius': '1rem'
                } as CSSProperties
            }
            toastOptions={{
                classNames: {
                    toast: 'font-sans shadow-card gap-3',
                    title: 'font-semibold text-[0.9rem]',
                    description: 'text-muted-foreground'
                }
            }}
            {...props}
        />
    )
}

export { Toaster }
